export const formatPricePerShareForInput = (value?: string | number | null) => {
  if (value === undefined || value === null || value === '') {
    return undefined;
  }

  const [integerPart, fractionalPart = ''] = String(value).split('.');
  const significantFraction = fractionalPart.replace(/0+$/, '');

  return `${integerPart}.${significantFraction.padEnd(2, '0')}`;
};
